import { useEffect, useRef, useState } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Box, Paper, Button, Alert, Chip, Grid } from '@mui/material';
import DOMPurify from 'dompurify';
import { useStore } from 'src/stores/store';
import Iconify from 'src/components/Iconify';
import useLocales from 'src/hooks/useLocales';
import Loader from 'src/components/loader/Loader';
import { PATH_DASHBOARD } from 'src/routes/paths';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { DateConverter } from 'src/sections/common/DateConverter';
import { baseUrl } from 'src/api/baseUrl';

function DiscountDocView() {
  const { ChoqorakCommonDropdown, ContractInfoStore } = useStore();
  const { loadTermsAndConditionDDL, TermsAndConditionOption } = ChoqorakCommonDropdown;
  const { selectedContractInfoDetail } = ContractInfoStore;
  const { translate } = useLocales();
  const [fontFamily, setFontFamily] = useState('Bahij-Zar-Regular');
  const [isLoad, setIsLoad] = useState(false);

  const reportExists = true;
  const contentToPrint = useRef(null);

  const handlePrint = useReactToPrint({
    pageStyle: `@page { size: A4; margin: 20mm; }`,
    content: () => contentToPrint.current,
  });

  useEffect(() => {
    setIsLoad(true);
    loadTermsAndConditionDDL(4)
      .then(() => {
        setIsLoad(false);
      })
      .catch((error) => {
        console.error('Error loading terms and conditions:', error);
        setIsLoad(false);
      });
  }, [loadTermsAndConditionDDL]);

  const changeStartDateToDateFormat = new Date(selectedContractInfoDetail?.contractStartDate!);
  const changeEndDateToDateFormat = new Date(selectedContractInfoDetail?.contractEndDate!);
  const changeTerminationDateFormat = new Date(selectedContractInfoDetail?.terminationDate!);

  const changediscountStartDateToDateFormat = new Date(
    selectedContractInfoDetail?.discountStartDate!
  );
  const changediscountEndDateToDateFormat = new Date(selectedContractInfoDetail?.discountEndDate!);
  const toEnglishDigits = (str: string) =>
    str.replace(/[۰-۹]/g, (d) => '0123456789'['۰۱۲۳۴۵۶۷۸۹'.indexOf(d)]);

  const startDate = toEnglishDigits(
    new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(
      changeStartDateToDateFormat!
    )
  );

  const endDate = toEnglishDigits(
    new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(
      changeEndDateToDateFormat!
    )
  );


  const DiscountStartDate = toEnglishDigits(
    new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(
      changediscountStartDateToDateFormat!
    )
  );

  const DiscountEndDate = toEnglishDigits(
    new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(
      changediscountEndDateToDateFormat!
    )
  );


  const TerminateDate = selectedContractInfoDetail?.terminationDate ? toEnglishDigits(
    new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(
      new Date(selectedContractInfoDetail?.terminationDate!)
    )
  ) : "";



  // const discountstartDate = toEnglishDigits(
  //   new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(
  //     changediscountStartDateToDateFormat!
  //   )
  // );

  // const discountendDate = toEnglishDigits(
  //   new Intl.DateTimeFormat('fa-IR', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(
  //     changediscountEndDateToDateFormat!
  //   )
  // );

  const {
    contractId,
    contractNumber,
    customerId,
    contractTypeId,
    rentCarrencyId,
    contractStartDate,
    contractEndDate,
    needApproval,
    initialRentAmount,
    finalRentPerMonth,
    advancePayment,
    customerName,
    contractType,
    contractTypePashto,
    rentCarrency,
    rentCarrencyPashto,
    isContractExpired,
    isLocked,
    isApproved,
    totalContractDurationRent,
    totalContractDurationPaidRent,
    contractStatusId,
    contractStatus,
    isTerminated,
    isAdvanceRecieved,
    terminationDescription,
    terminationDate,
    settlmentDeductionAmount,
    deductedAmountFromAdvancePayment,
    manuallyPaidAmount,
    refundedAdvancePayment,
    remainAmount,
    deductionDescription,
    advanceRecievedByUserId,
    advanceRecievedByUserName,
    approvedBy,
    approvedByName,
    discountStartDate,
    discountEndDate,
    customerFatherName,
    customerGrandFatherName,
    customerPhone,
    customerTazkiraNo,
    customerMainProvence,
    customerMainProvencePashto,
    customerMainDistrict,
    customerMainDistrictPashto,
    customerMainAddress,
    customerCurrentProvence,
    customerCurrentProvencePashto,
    customerCurrentDistrict,
    customerCurrentDistrictPashto,
    customerCurrentAddress,
    customerPashtoName,
    contractDuration,
    customerTazkiraRegNo,
    customerTazkiraPageNo,
    customerTazkiraJoldNo,
    customerPhotoPath,
    shopId,
    shopCode,
    floorId,
    floorCode,

    shopTypePashto,
    blockId,
    blockName,
    contractCreatorPashtoName,
    contractCreatorFatherPashtoName,

    totalContractDurationRentWithoutDiscount,
    contractCreatorPashtoGrandFatherName,
  } = selectedContractInfoDetail ?? {};
  // .replace(/\d/g, (d) => '۰۱۲۳۴۵۶۷۸۹'[+d])
  const dynamicFields = {
    contractId: contractId?.toString() || '',
    contractNumber: contractNumber?.toString() || '',
    customerId: customerId?.toString() || '',
    contractTypeId: contractTypeId?.toString() || '',
    rentCarrencyId: rentCarrencyId?.toString() || '',
    contractStartDate: startDate?.toString() || '',
    contractEndDate: endDate?.toString() || '',
    discountStartDate: DiscountStartDate?.toString() || '',
    discountEndDate: DiscountEndDate?.toString() || '',
    terminationDate: TerminateDate?.toString() || '',
    needApproval: needApproval?.toString() || '',
    initialRentAmount: initialRentAmount?.toString() || '',
    finalRentPerMonth: finalRentPerMonth?.toString() || '',
    advancePayment: advancePayment?.toString() || '',
    customerName: customerName?.toString() || '',
    contractType: contractType?.toString() || '',
    contractTypePashto: contractTypePashto?.toString() || '',
    rentCarrency: rentCarrency?.toString() || '',
    rentCarrencyPashto: rentCarrencyPashto?.toString() || '',
    isContractExpired: isContractExpired?.toString() || '',
    isLocked: isLocked?.toString() || '',
    isApproved: isApproved?.toString() || '',
    totalContractDurationRent: totalContractDurationRent?.toString() || '',
    totalContractDurationPaidRent: totalContractDurationPaidRent?.toString() || '',
    contractStatusId: contractStatusId?.toString() || '',
    contractStatus: contractStatus?.toString() || '',
    isTerminated: isTerminated?.toString() || '',
    // contractDuration: contractDuration?.toString() || '',
    contractDuration: `\u200F${contractDuration?.toString()}` || '',
    isAdvanceRecieved: isAdvanceRecieved?.toString() || '',
    terminationDescription: terminationDescription?.toString() || '',
    settlmentDeductionAmount: settlmentDeductionAmount?.toString() || '',
    deductedAmountFromAdvancePayment: deductedAmountFromAdvancePayment?.toString() || '',
    manuallyPaidAmount: manuallyPaidAmount?.toString() || '',
    refundedAdvancePayment: refundedAdvancePayment?.toString() || '',
    remainAmount: remainAmount?.toString() || '',
    deductionDescription: deductionDescription?.toString() || '',
    advanceRecievedByUserId: advanceRecievedByUserId?.toString() || '',
    advanceRecievedByUserName: advanceRecievedByUserName?.toString() || '',
    approvedBy: approvedBy?.toString() || '',
    approvedByName: approvedByName?.toString() || '',
    // discountStartDate: discountstartDate?.toString() || '',
    // discountEndDate: discountendDate?.toString() || '',
    customerFatherName: customerFatherName?.toString() || '',
    customerGrandFatherName: customerGrandFatherName?.toString() || '',
    customerPhone: customerPhone?.toString() || '',
    customerTazkiraNo: customerTazkiraNo?.toString() || '',
    customerTazkiraJoldNo: customerTazkiraJoldNo?.toString() || '',
    customerTazkiraPageNo: customerTazkiraPageNo?.toString() || '',
    customerTazkiraRegNo: customerTazkiraRegNo?.toString() || '',
    customerMainProvence: customerMainProvence?.toString() || '',
    customerMainProvencePashto: customerMainProvencePashto?.toString() || '',
    customerMainDistrict: customerMainDistrict?.toString() || '',
    customerMainDistrictPashto: customerMainDistrictPashto?.toString() || '',
    customerMainAddress: customerMainAddress?.toString() || '',
    customerCurrentProvence: customerCurrentProvence?.toString() || '',
    customerCurrentProvencePashto: customerCurrentProvencePashto?.toString() || '',
    customerCurrentDistrict: customerCurrentDistrict?.toString() || '',
    customerCurrentDistrictPashto: customerCurrentDistrictPashto?.toString() || '',
    customerCurrentAddress: customerCurrentAddress?.toString() || '',
    customerPashtoName: customerPashtoName?.toString() || '',
    customerPhotoPath: customerPhotoPath?.toString() || '',
    shopId: shopId?.toString() || '',
    shopCode: shopCode?.toString() || '',
    floorId: floorId?.toString() || '',
    floorCode: floorCode?.toString() || '',
    shopTypePashto: shopTypePashto?.toString() || '',
    blockId: blockId?.toString() || '',
    blockName: blockName?.toString() || '',
    contractCreatorPashtoName: contractCreatorPashtoName?.toString() || '',
    contractCreatorFatherPashtoName: contractCreatorFatherPashtoName?.toString() || '',
    contractCreatorPashtoGrandFatherName: contractCreatorPashtoGrandFatherName?.toString() || '',
    totalContractDurationRentWithoutDiscount:
      totalContractDurationRentWithoutDiscount?.toString() || '',
  };

  // Function to replace dynamic placeholders with values from dynamicFields object
  // const replaceDynamicFields = (content: string) => {
  //   let updatedContent = content;
  //   Object.keys(dynamicFields).forEach((key) => {
  //     const regex = new RegExp(`{${key}}`, 'g'); // Find placeholder {key}
  //     updatedContent = updatedContent.replace(
  //       regex,
  //       dynamicFields[key as keyof typeof dynamicFields]
  //     );
  //   });
  //   return updatedContent;
  // };

  const replaceDynamicFields = (content: string) => {
    let updatedContent = content;

    Object.keys(dynamicFields).forEach((key) => {
      const regex = new RegExp(`\\{${key}\\}`, 'g'); // بهبود یافتن الگو برای پیدا کردن {key}
      const value = dynamicFields[key as keyof typeof dynamicFields];

      // بررسی مقدار null، undefined، و جایگزینی مقدار نامعتبر با ""
      updatedContent = updatedContent.replace(
        regex,
        value && value !== null && value !== undefined && value !== '' ? value : ''
      );
    });
    // {customerTazkiraRegNo} {customerTazkiraJoldNo} {customerTazkiraPageNo}

    return updatedContent;
  };

  // Sanitize and replace dynamic fields in content
  const decodedContent = TermsAndConditionOption?.[0]?.text?.replace(/\\\"/g, '"') || '';
  let sanitizedContent = DOMPurify.sanitize(decodedContent);

  // Replace placeholders with dynamic values
  sanitizedContent = replaceDynamicFields(sanitizedContent);

  //#region split content

  const [contentPages, setContentPages] = useState<string[]>([]); // State to store the split pages

  const handleSplitContent = (content: string) => {
    const pageHeight = 1200; // Height of one page in pixels (adjust as needed)
    const container = document.createElement('div');
    container.style.width = '800px'; // Set width similar to the page container
    container.style.position = 'absolute  ';
    container.style.visibility = 'hidden';
    container.innerHTML = content;

    document.body.appendChild(container);

    let currentPageContent = '';
    let pages: string[] = [];

    const children = Array.from(container.children);

    let currentHeight = 0;
    for (const child of children) {
      // Add content one by one and check for overflow
      container.innerHTML = currentPageContent + child.outerHTML;

      // Check if the content exceeds the page height
      if (container.offsetHeight > pageHeight) {
        pages.push(currentPageContent); // Push the current page's content
        currentPageContent = child.outerHTML; // Start a new page
      } else {
        currentPageContent += child.outerHTML; // Continue appending content
      }
    }

    // If any content remains after the loop, add it to the last page
    if (currentPageContent) {
      pages.push(currentPageContent);
    }

    document.body.removeChild(container); // Clean up

    return pages; // Return the content divided into pages
  };

  useEffect(() => {
    // Example content to split
    const content = sanitizedContent; // This can be any large content
    const splitContent = handleSplitContent(content);

    setContentPages(splitContent); // Store the result in state
  }, [sanitizedContent]); // Run only once when the component mounts

  //#endregion

  const tableCellStyle: React.CSSProperties = {
    border: '1px solid black',

    textAlign: 'center',
    fontSize: '14px',
  };

  const tableHeaderStyle: React.CSSProperties = {
    border: '1px solid black',

    textAlign: 'center',
    fontWeight: 'bold',
    fontSize: '16px',
  };

  const signatureCellStyle: React.CSSProperties = {
    textAlign: 'center',
    fontSize: '14px',
  };

  let Url = baseUrl;

  return (
    <Box sx={{ p: 2 }} className="h-screen overflow-hidden overflow-y-auto">
      <Paper elevation={3} sx={{ p: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Button
            variant="contained"
            color="error"
            startIcon={<Iconify icon="eva:arrow-ios-back-fill" />}
            component={RouterLink}
            to={PATH_DASHBOARD.ContractInfo.list}
          >
            {' '}
            {translate('CRUD.BackToList')}
          </Button>

          <Button
            variant="contained"
            color="success"
            startIcon={<Iconify icon="eva:printer-outline" />}
            onClick={handlePrint}
          >
            {translate('Income.Print')}
          </Button>
        </Box>
      </Paper>

      {isLoad ? (
        <Loader />
      ) : reportExists ? (
        <Box ref={contentToPrint}>
          <Box sx={{}}>
            <Box
              sx={{
                width: '210mm',
                height: '297mm',
                margin: '0 auto',
                backgroundColor: 'white',
                color: 'black',
                position: 'relative',
                fontFamily,
                padding: '5mm',
                boxSizing: 'border-box',
                direction: 'rtl',
                border: '1px solid lightgray',
              }}
            >
              {/* Header Area */}
              <Box
                sx={{
                  textAlign: 'center',
                  fontWeight: 'bold',
                  fontSize: '16px',
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <img
                  src="/Images/Choqorak Brand logo-03.png"
                  alt="Logo"
                  style={{
                    width: '120px',
                    height: '120px',
                    position: 'absolute',
                    top: '0px',
                  }}
                />
                <div style={{ marginTop: '70px' }}>
                  <div>سـرای چقـــرک (مرکز پخش مواد خوراکی افغانستان)</div>
                  <div>ریاست اداری</div>
                </div>
              </Box>

              {/* Table Layout: Proposal and Ruling */}
              <Grid container sx={{ border: '1px solid black', borderTop: 'none' }}>
                {/* Header Row */}
                <Grid container>
                  <Grid
                    item
                    xs={1}
                    sx={{
                      border: '1px solid black',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      fontSize: '14px',
                      padding: '4px',
                    }}
                  >
                    شماره
                  </Grid>
                  <Grid
                    item
                    xs={6}
                    sx={{
                      border: '1px solid black',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      fontSize: '14px',
                      padding: '4px',
                    }}
                  >
                    پیشنهاد
                  </Grid>
                  <Grid
                    item
                    xs={5}
                    sx={{
                      border: '1px solid black',
                      textAlign: 'center',
                      fontWeight: 'bold',
                      fontSize: '14px',
                      padding: '4px',
                    }}
                  >
                    احکام
                  </Grid>
                </Grid>

                {/* Content Row */}
                <Grid container>
                  {/* شماره column */}
                  <Grid
                    item
                    xs={1}
                    sx={{
                      borderLeft: '1px solid black',
                      padding: '10px',
                      minHeight: '210mm',
                    }}
                  >
                    {/* شماره content if needed */}
                  </Grid>

                  {/* پیشنهاد column */}
                  <Grid
                    item
                    xs={6}
                    sx={{

                      padding: '10px',
                      minHeight: '210mm',
                      textAlign: 'right',
                      fontSize: '14px',
                      overflow: 'hidden',
                    }}
                  >
                    <div
                      className="content"
                      style={{ direction: 'rtl', textAlign: 'right', height: '100%' }}
                      dangerouslySetInnerHTML={{ __html: sanitizedContent }}
                    />
                  </Grid>

                  {/* احکام column */}
                  <Grid
                    item
                    xs={5}
                    sx={{
                      minHeight: '210mm',
                      textAlign: 'center',
                      fontSize: '14px',
                      fontWeight: 'bold',
                      borderRight: '1px solid black',
                    }}
                  >
                    {/* Add Ruling content here if needed */}
                  </Grid>
                </Grid>
              </Grid>

              {/* Footer */}
              <Box
                sx={{
                  position: 'absolute',
                  bottom: '10mm',
                  width: '100%',
                  textAlign: 'center',
                }}
              >
                <img
                  src="/Images/footer QGC_Dari-01.png"
                  alt="Footer"
                  style={{ width: '700px', height: '120px' }}
                />
              </Box>
            </Box>
          </Box>
        </Box>



      ) : (
        <Alert severity="error">
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <span>There is no document selected. Please go back.</span>
            <Chip
              sx={{ mt: -1, ml: 1 }}
              color="secondary"
              label={translate('CRUD.BackToList')}
              onClick={() => console.log('Clear selection and navigate back')}
            />
          </Box>
        </Alert>
      )}
    </Box>
  );
}

export default DiscountDocView;
